import {oneOf} from 'shared/store';
import { observable, computed, override, makeObservable } from 'mobx';
import Answer from './Answer';
import {QAQuestion} from 'main/stores/questions';

class Question extends QAQuestion {
  id;
  name;
  answer;
  _relations = {
    questionType: oneOf([
      'text_field',
      'text_area',
      'attachment',
      'multiple_choice',
      'multi_select'
    ]),
    answer: Answer
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      answer: observable,
      updateText: override,
      translatableQuestionType: computed,
      questionName: override
    });

    this.merge(other);
  }

  updateText(value) {
    this.merge({name: value});
  }

  get translatableQuestionType() {
    return `models.job_application_question.question_type.${this.questionType}`;
  }

  get questionName() {
    return this.name;
  }
}

export default Question;
